import { setTheme } from "@/redux/actions/theme-actions";
import { useDispatch, useSelector } from "react-redux";

const useAppTheme = () => {
  const dispatch = useDispatch();
  const activeTheme = useSelector((state) => state.theme.activeTheme);
  const isDark = activeTheme === "wayaDark";

  const toggleTheme = () => {
    dispatch(setTheme(isDark ? "waya" : "wayaDark"));
  };

  const changeTheme = (themeName) => {
    dispatch(setTheme(themeName));
  };

  return { activeTheme, isDark, toggleTheme, changeTheme };
};

export default useAppTheme;